import { createContext, useState, useContext } from "react";

const ROLE = {
  ADMIN: 4,
  TL: 2,
};

const AuthContext = createContext({
  role: null,
  isAdmin: false,
  isTl: false,
  isEmployee: false,
  loginUser: "",
  setLoginUser: () => {},
  setRole: () => {},
});

export const AuthProvider = ({ children }) => {
  const [role, setRole] = useState(null);
  const [loginUser, setLoginUser] = useState("");

  const isAdmin = role === ROLE.ADMIN;
  const isTl = role === ROLE.TL;
  const isEmployee = !isAdmin && !isTl;

  return (
    <AuthContext.Provider
      value={{
        role,
        loginUser,
        setLoginUser,
        isAdmin,
        isTl,
        isEmployee,
        setRole,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Optional helper hook for cleaner usage
export const useAuth = () => useContext(AuthContext);
